import type {
    Order,
    OrderPollingResult,
    SkuInput,
    PaymentCheckReqParams,
    PaymentCheckResult,
} from './entities/payment';
import {request} from '@/services';
import type {OrderId} from '@/services/commerce/type';

const PAYMENT_ENDPOINTS = {
    /** 会员订阅下单 */
    CREATE_ORDER_MEMBERSHIP: 'proxy-aicomic/membership/subscribe',
    /** 积分充值下单 */
    CREATE_ORDER_POINTS: 'proxy-aicomic/points/recharge',
    /** 查询订单状态（供轮询用） */
    QUERY_ORDER: 'proxy-aicomic/payment/order/query',
    /** 支付价格校验 */
    PAYMENT_PRICE_CHECK: '/proxy-aicomic/payment/check',
} as const;

/** 会员订阅/升级下单 */
export const createMembershipOrder = (sku: SkuInput) =>
    request.post<Order>(PAYMENT_ENDPOINTS.CREATE_ORDER_MEMBERSHIP, {skuId: sku.skuId});

/** 积分充值下单 */
export const createPointsOrder = (sku: SkuInput) =>
    request.post<Order>(PAYMENT_ENDPOINTS.CREATE_ORDER_POINTS, {skuId: sku.skuId});

/** 查询订单状态（需透传 signal，让 react-query 能中止 in-flight 请求） */
export const queryOrder = (orderId: OrderId, opts?: {signal?: AbortSignal}) =>
    request.get<OrderPollingResult>(PAYMENT_ENDPOINTS.QUERY_ORDER, {
        signal: opts?.signal,
        params: {orderId},
    });

/** 支付价格校验 */
export const checkPaymentPrice = (params: PaymentCheckReqParams) =>
    request.post<PaymentCheckResult>(PAYMENT_ENDPOINTS.PAYMENT_PRICE_CHECK, params);
